/**
 * useHideCookieBanner — hides CookieHub's persistent consent banner on
 * admin/internal routes where it adds noise and intercepts pointer events
 * on dashboard controls. Restores the banner's display on unmount so
 * legitimate consent flow on public pages stays intact.
 *
 * No-op for users who have already dismissed consent (banner won't be
 * present in the DOM in the first place).
 */
import { useEffect } from 'react';

const SELECTOR = '.ch2-container, .ch2-dialog, .ch2';

const setHidden = (hidden) => {
  document.querySelectorAll(SELECTOR).forEach((el) => {
    if (hidden) {
      el.dataset.adminHidden = '1';
      el.style.display = 'none';
    } else if (el.dataset.adminHidden === '1') {
      el.style.display = '';
      delete el.dataset.adminHidden;
    }
  });
};

const useHideCookieBanner = () => {
  useEffect(() => {
    setHidden(true);
    // CookieHub may inject the banner after mount; observe and re-hide.
    const obs = new MutationObserver(() => setHidden(true));
    obs.observe(document.body, { childList: true, subtree: true });
    // Stop after 8s — by then the banner is either present or not coming.
    const stop = window.setTimeout(() => obs.disconnect(), 8000);
    return () => {
      obs.disconnect();
      window.clearTimeout(stop);
      setHidden(false);
    };
  }, []);
};

export default useHideCookieBanner;
